import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from "@angular/router";
import {Observable, of} from "rxjs";
import {GestionnairesService} from "app/demat/common/services/individus/gestionnaires.service";
import {IndividuService} from "@Common/core/services";
import {switchMap} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class FormGuardService  {
  // roles: [];
  params: {};

  constructor(private gestSvc: GestionnairesService, private individuSvc: IndividuService, private router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    // this.roles = route.data?.roles || this.roles;
    this.params = route.data?.params ?? this.params;
    const paramFormUuid = route.data?.paramFormUuid ?? 'id';
    const uuid = route.paramMap.get(paramFormUuid);

    console.log('FormGuardService :', paramFormUuid, ' ', uuid);
    return this.individuSvc.individu$.pipe(
      switchMap(
        ind => this.gestSvc.gestionnaireFormulaire(uuid, ind.user).pipe(
          switchMap(
            res => {
              const enable = res.length === 1;
              if (!enable) this.router.navigateByUrl('/forbidden', {state: this.params});
              return of(enable);
            }
          )
        )
      )
    )
  }
}
